import { AgentFinancialResponse, AgentSource } from '../../../api/events-client/events-client.type';
import type { DataPoint } from '../../financials/charts/shared/shared.type';
import { AgenticFinancialsChartCategory } from './agentic-financials.type';

/**
 * Get the data for the chart
 * @param {AgentFinancialResponse} data - The data to chart
 * @param {AgenticFinancialsChartCategory} selectedCategory - The category to chart
 * @param {AgentSource | 'all'} selectedAgentSource - The agent source to chart
 * @param {'cost' | 'tokens'} viewBy - The view to chart by
 * @returns {DataPoint[]} - The data for the chart
 */
const getAgenticFinancialsChartData = (
  data: AgentFinancialResponse,
  selectedCategory: AgenticFinancialsChartCategory,
  selectedAgentSource: AgentSource | 'all',
  viewBy: 'cost' | 'tokens',
): DataPoint[] => {
  const chartData =
    data?.dates
      ?.slice()
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .map((date) => {
        const dataPoint: Record<string, any> = {
          date,
        };

        (data?.[selectedCategory] as any[])?.forEach((item: any) => {
          let value = 0;
          if (selectedAgentSource === 'all') {
            value = item.chart_data?.[date]?.[viewBy]?.total ?? 0;
          } else {
            value = item.chart_data?.[date]?.[viewBy]?.by_agent_source?.[selectedAgentSource] ?? 0;
          }
          dataPoint[item.code ?? item.name] = value;
        });

        return dataPoint as DataPoint;
      }) ?? [];

  return chartData;
};

export { getAgenticFinancialsChartData };
